import React from "react";
import { motion } from "framer-motion";
import { FaLocationDot } from "react-icons/fa6";
import { IoIosMail, IoIosCall } from "react-icons/io";
import Footerform from "./Footerform";
import { socialLinks } from "../data/socialLinks";
import {links} from "../data/links";



export default function Footer() {
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15,
      },
    },
  };
  
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: "easeOut",
      },
    },
  };
  
  const fadeLeft = {
    hidden: {
      opacity: 0,
      x: -35,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.7,
        ease: "easeOut",
      },
    },
  };
  
  const fadeRight = {
    hidden: {
      opacity: 0,
      x: 35,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.7,
        ease: "easeOut",
      },
    },
  };
  return (
<footer className="relative overflow-hidden bg-gradient-to-r from-[#07071c] via-[#0b0b2a] to-[#14001f] text-white">

<Footerform />

<motion.div
  variants={containerVariants}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, amount: 0.15 }}
  className="max-w-6xl mx-auto pb-8 px-6 pt-16"
>

  {/* Heading */}

  <motion.div
    variants={fadeUp}
    className="mb-5"
  >
    <p className="text-sm tracking-widest text-start">
      GET IN TOUCH
    </p>

    <h2 className="text-3xl sm:text-4xl font-bold text-start">
      Contact Us
    </h2>
  </motion.div>

  {/* Grid */}

  <motion.div
    variants={containerVariants}
    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10"
  >

    {/* Company Info */}

    <motion.div
      variants={fadeLeft}
    >

      <h3 className="text-lg font-semibold border-b border-white/20 pb-2 mb-4 text-left">
        Samrat Tech IT Solutions
      </h3>

      <div className="space-y-4 text-md text-white">

        {/* Address */}

        <motion.div
          variants={fadeUp}
          whileHover={{
            x: 6,
          }}
          className="flex items-start gap-3"
        >
          <FaLocationDot className="mt-1 text-[#b31159]" />

          <p className="text-start">
            Ground Floor, Plot No.17,
            New Bharat Colony,
            Mata Amritanandmayi Marg,
            RWA Awadh Enclave,
            Faridabad,
            Haryana - 121002
          </p>

        </motion.div>

        {/* Email */}

        <motion.div
          variants={fadeUp}
          whileHover={{
            x: 6,
          }}
          className="flex items-center gap-3 footer-mail max-[400px]:text-[13px]"
        >
          <IoIosMail className="text-[#b31159]" />

          <a
            href="mailto:sales@samrattechitsolutions.com"
            className="relative z-10 text-white hover:text-[#b31159] transition duration-300"
          >
            sales@samrattechitsolutions.com
          </a>

        </motion.div>

        {/* Phone */}

        <motion.div
          variants={fadeUp}
          whileHover={{
            x: 6,
          }}
          className="flex items-center gap-3 max-[400px]:text-[13px]"
        >
          <IoIosCall className="text-[#b31159]" />

          <a
            href="tel:+917897648842"
            className="text-white-300 hover:text-[#b31159] transition duration-300"
          >
            +91-7897648842
          </a>

        </motion.div>

      </div>

      {/* Social Icons */}

      <div className="flex gap-4 mt-6">

        {socialLinks.map((item, i) => {
          const Icon = item.icon;

          if (!Icon) return null;

          return (
            <motion.a
              key={i}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{
                y: -6,
                scale: 1.1,
                rotate: 8,
              }}
              whileTap={{
                scale: 0.95,
              }}
              transition={{
                duration: 0.25,
              }}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 border border-white/10 hover:bg-gradient-to-r hover:from-pink-500 hover:to-purple-500 transition"
            >
              <Icon className="text-white text-sm" />
            </motion.a>
          );
        })}

      </div>

    </motion.div>
          {/* ================= Quick Links ================= */}

          <motion.div
        variants={fadeUp}
        className="md:px-16"
      >
        <h4 className="text-lg font-semibold text-white mb-4 text-start">
          Quick Links
        </h4>

        <ul className="space-y-3 text-white-300 text-start">
          {links.map((link, i) => (
            <motion.li
              key={i}
              variants={fadeUp}
            >
              <motion.a
                href={link.link}
                whileHover={{
                  x: 8,
                }}
                transition={{
                  duration: 0.25,
                }}
                className="inline-flex items-center gap-2 hover:text-[#b31159] transition duration-300 group"
              >
                {link.name}
              </motion.a>
            </motion.li>
          ))}
        </ul>
      </motion.div>

      {/* ================= Map Section ================= */}

      <motion.div
        variants={fadeRight}
      >
        <h4 className="text-lg font-semibold text-white text-start mb-4">
          Our Location
        </h4>

        <motion.div
          whileHover={{
            y: -6,
          }}
          transition={{
            duration: 0.3,
          }}
          className="relative p-[2px] rounded-2xl overflow-hidden"
        >

          {/* Glow Border */}

          <div
            className="absolute inset-0 rounded-2xl bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500
            opacity-70 blur-md animate-border"
          ></div>

          {/* Map */}

          <div className="relative rounded-2xl overflow-hidden border border-white/10">

            <motion.iframe
              whileHover={{
                scale: 1.03,
              }}
              transition={{
                duration: 0.4,
              }}
              src="https://www.google.com/maps?q=28.41625,77.35208&z=18&output=embed"
              width="100%"
              height="220"
              style={{
                border: 0,
                filter: "grayscale(1) invert(0.9) contrast(1.2)",
              }}
              loading="lazy"
            ></motion.iframe>

            {/* Overlay */}

            <div className="absolute inset-0 bg-gradient-to-t from-[#07071c]/60 to-transparent pointer-events-none"></div>

          </div>

        </motion.div>

        {/* Map Link */}

        <motion.a
          href="https://www.google.com/maps?q=28.41625,77.35208"
          target="_blank"
          rel="noreferrer"
          whileHover={{
            x: 6,
          }}
          transition={{
            duration: 0.25,
          }}
          className="text-[#b31159] text-sm mt-2 inline-block hover:underline"
        >
          View on Google Maps →
        </motion.a>

      </motion.div>
            {/* ================= Bottom ================= */}

            </motion.div>

<motion.div
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{
    once: true,
    amount: 0.2,
  }}
  className="border-t border-white/10 mt-12 pt-6 text-start md:text-center text-sm text-white"
>
  <motion.p
    initial={{
      opacity: 0,
      y: 15,
    }}
    whileInView={{
      opacity: 1,
      y: 0,
    }}
    transition={{
      duration: 0.6,
    }}
  >
    © {new Date().getFullYear()} Samrat Tech IT Solutions. All rights reserved.
  </motion.p>
</motion.div>

</motion.div>
</footer>
);
}

